import { SvgIcon } from '@mui/material';
import { FlexButtonStyles } from './styles';
import { CustomButtomProps } from './types';

export const FlexButton: React.FC<CustomButtomProps> = ({
  text,
  handleClick,
  startIcon,
  endIcon,
  disabled = false,
  fullWidth,
  $backgroundColor,
  $outline = false,
  size = 'medium',
  option,
  selectValue,
  'data-testid': dataTestId,
}) => {
  return (
    <FlexButtonStyles
      size={size}
      $backgroundColor={$backgroundColor}
      $outline={$outline}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={startIcon && <SvgIcon component={startIcon} />}
      endIcon={endIcon && <SvgIcon component={endIcon} />}
      onClick={() => handleClick?.()}
      className={selectValue === option ? 'select-item' : ''}
      data-testid={dataTestId}
    >
      {text}
    </FlexButtonStyles>
  );
};
